import Login from '@/views/login'

export default {
    path: '/',
    component: {
        template: '<router-view></router-view>'
    },
    children: [
        {
            path: '/login',
            component: Login,
            meta: {
                title: '登录绑定'
            }
        }
    ]
}
    
